import { PartnerMember } from "../api/partners";

/**
 * Build a CSV of partner members (Name, Email, Group, Created At) and trigger a
 * browser download. Shared by the read-only roster and the manage-members
 * dialog so both export the same shape.
 */
export const downloadMembersCsv = (
  members: PartnerMember[],
  groupName: string,
  fileBaseName: string
): void => {
  const escape = (value: string) => `"${value.replace(/"/g, '""')}"`;
  const header = ["Name", "Email", "Group", "Created At"];
  const rows = members.map((m) => [
    m.displayName,
    m.email,
    groupName,
    m.createdAt ? new Date(m.createdAt).toISOString() : "",
  ]);
  const csv = [header, ...rows]
    .map((row) => row.map((cell) => escape(cell ?? "")).join(","))
    .join("\r\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileBaseName.replace(/[^a-z0-9]+/gi, "_")}_members.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
